import { finops } from "../lib/content";
import { CheckIcon } from "./Icons";

/**
 * FinOps framing section.
 *
 * Rendered on a dark panel on purpose: it is the positioning statement of the
 * page ("visibility first, savings follow"), so it should read as a deliberate
 * break rather than another white card grid.
 */
export default function FinOpsSection() {
  return (
    <section id="finops" className="relative overflow-hidden bg-brand-900">
      <div className="pointer-events-none absolute inset-0 bg-grid opacity-[0.12]" />

      <div className="container-page relative py-20 sm:py-28">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-brand-200">
            {finops.eyebrow}
          </span>
          <h2 className="mt-4 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            {finops.heading}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-brand-100/90 sm:text-lg">
            {finops.intro}
          </p>
        </div>

        <ol className="mt-14 grid gap-6 lg:grid-cols-3">
          {finops.pillars.map((pillar) => (
            <li
              key={pillar.step}
              className="rounded-2xl border border-white/10 bg-white/5 p-7 backdrop-blur"
            >
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-brand-500 text-sm font-bold text-white">
                {pillar.step}
              </span>
              <h3 className="mt-5 text-base font-semibold text-white">{pillar.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-100/80">{pillar.body}</p>

              <ul className="mt-5 space-y-2.5 border-t border-white/10 pt-5">
                {pillar.items.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm text-brand-50">
                    <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-500/25 text-brand-100">
                      <CheckIcon className="h-3 w-3" />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
